// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__2I821","title-wrapper":"Banner_title-wrapper__29sX6","title":"Banner_title__pQZoG","options":"Banner_options__376fO"};